export type JobOfferStatus = 'draft' | 'published' | 'archived';

export type JobOfferContractType =
  | 'cdi'
  | 'cdd'
  | 'freelance'
  | 'stage'
  | 'alternance';

export type JobOfferRemoteType = 'no' | 'partial' | 'full_remote';

export interface JobOffer {
  id: string;
  title: string;
  slug: string;

  contract_type: JobOfferContractType;
  location_city: string;
  remote_type: JobOfferRemoteType;

  description: string;
  profile: string;

  status: JobOfferStatus;

  internal_reference: string | null;
  sector: string | null;

  salary_range: string | null;
  salary_min: number | null;
  salary_max: number | null;
  salary_currency: string | null;

  published_at: string | null;
  valid_through: string | null;

  featured: boolean;

  image_url: string | null;
  company_name: string | null;
  company_logo_url: string | null;

  meta_title: string | null;
  meta_description: string | null;

  hiring_organization_name: string | null;
  hiring_organization_logo: string | null;
  hiring_organization_url: string | null;

  job_location_street_address: string | null;
  job_location_postal_code: string | null;
  job_location_country: string | null;

  parcours_id: string | null;

  created_at: string;
  updated_at: string;
}

export const CONTRACT_TYPE_LABELS: Record<JobOfferContractType, string> = {
  cdi: 'CDI',
  cdd: 'CDD',
  freelance: 'Freelance',
  stage: 'Stage',
  alternance: 'Alternance',
};

export const REMOTE_TYPE_LABELS: Record<JobOfferRemoteType, string> = {
  no: 'Présentiel',
  partial: 'Hybride',
  full_remote: 'Full remote',
};

export const STATUS_LABELS: Record<JobOfferStatus, string> = {
  draft: 'Brouillon',
  published: 'Publiée',
  archived: 'Archivée',
};